import React, { useEffect, useState } from "react";
import { printElement, printImg } from "../../master/Print";
import AttendanceStudentTable from "./AttendanceStudentTable";
import StudentTable from "../../student/components/StudentTable";
import AttendanceStaffTable from "./AttendanceStaffTable";
import { formatToDate } from "../../master/FormatToDateTime";
import { studentAttendanceRangeSummary } from "../../../api/Attendance";
import { useNavigate } from "react-router-dom";
import StaffLowAttendanceList from "../../staffs/components/StaffLowAttendanceList";
import StudentAttendanceMesstable from "./StudentAttendanceMesstable";
import { printModalContent } from "../../master/PrintReport";

export default function DashboardModal({
  setLoading,
  allFilter,
  setAllFilter,
  dataSummary,
  refreshDashboard,
}) {
  const [data, setStudents] = useState([]);
  const navigate = useNavigate();

  const getAttendanceSummaryStudents = async () => {
    let addUrl = "";

    Object.keys(allFilter || {}).forEach((key) => {
      if (allFilter[key]) {
        addUrl += `&${key}=${encodeURIComponent(allFilter[key])}`;
      }
    });

    const response = await studentAttendanceRangeSummary(addUrl);

    if (response?.data?.status) {
      setStudents(response.data.data.students || []);
    }
  };
  useEffect(() => {
    if (allFilter?.table === "attendance_summary") {
      getAttendanceSummaryStudents();
    }
  }, [allFilter]);

  const printCurrent = (title) =>
    printModalContent("ModalPrintArea", {
      title,
      subtitle: `${allFilter?.from_date || allFilter?.date || ""}`,
      meta: [`Date: ${allFilter?.date || ""}`],
      landscape: true,
    });

  return (
    <div
      className="modal fade"
      id="MainModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header bg-label-primary py-3">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Attendance
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div id="ModalPrintArea">
              {allFilter?.table === "studentAttendance" && (
                <div className="row g-2 align-items-center">
                  <div className="col-sm-6">
                    <h4 className="text-primary m-0">Attendance</h4>
                  </div>
                  <div className="col-sm-6 text-end">
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => printCurrent("Student Attendance")}
                      >
                        <i className="ri-printer-line"></i>
                      </button>
                    </div>
                  </div>

                  <div className="col-12">
                    <hr />
                    {/* <div className="table-responsive">
                    <AttendanceStudentTable
                      filters={allFilter}
                      setFilters={setAllFilter}
                      refreshDashboard={refreshDashboard}
                    />
                  </div> */}
                    <div className="table-responsive">
                      <StudentAttendanceMesstable
                        filters={allFilter}
                        setFilters={setAllFilter}
                        refreshDashboard={refreshDashboard}
                        isModal={true}
                      />
                    </div>
                  </div>
                </div>
              )}
              {allFilter?.table === "student" && (
                <div className="row g-2 align-items-center">
                  <div className="col-sm-6">
                    <h4 className="text-primary m-0">Student List</h4>
                  </div>
                  <div className="col-sm-6 text-end">
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => printCurrent("Student List")}
                      >
                        <i className="ri-printer-line"></i>
                      </button>
                    </div>
                  </div>

                  <div className="col-12">
                    <hr />
                    <div className="table-responsive">
                      <StudentTable
                        filters={allFilter}
                        setFilters={setAllFilter}
                      />
                    </div>
                  </div>
                </div>
              )}
              {allFilter?.table === "staffAttendance" && (
                <div className="row g-2 align-items-center">
                  <div className="col-sm-6">
                    <h4 className="text-primary m-0">Attendance</h4>
                  </div>
                  <div className="col-sm-6 text-end">
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => printElement("PrintDiv")}
                      >
                        <i className="ri-printer-line"></i>
                      </button>
                    </div>
                  </div>

                  <div className="col-12">
                    <hr />
                    <div className="table-responsive">
                      <AttendanceStaffTable
                        filters={allFilter}
                        setFilters={setAllFilter}
                        refreshDashboard={refreshDashboard}
                      />
                    </div>
                  </div>
                </div>
              )}
              {allFilter?.table === "staff" && (
                <div className="row g-2 align-items-center">
                  <div className="col-sm-6">
                    <h4 className="text-primary m-0">Staff List</h4>
                  </div>
                  <div className="col-sm-6 text-end">
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => printElement("PrintDiv")}
                      >
                        <i className="ri-printer-line"></i>
                      </button>
                    </div>
                  </div>

                  <div className="col-12">
                    <hr />
                    <div className="table-responsive">
                      {allFilter?.table === "staff" && (
                        <StaffLowAttendanceList
                          filters={allFilter}
                          setFilters={setAllFilter}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}

              {allFilter?.table === "attendance_summary" && (
                <div className="row g-2 align-items-center">
                  <div className="col-sm-6">
                    <h4 className="text-primary m-0">
                      Attendance Summary Students
                    </h4>
                  </div>

                  <div className="col-sm-6 text-end">
                    <button
                      className="btn btn-outline-danger"
                      onClick={() =>
                        printCurrent("Attendance Summary Students")
                      }
                    >
                      <i className="ri-printer-line"></i>
                    </button>
                  </div>

                  <div className="col-12">
                    <hr />
                    <>
                      <div className="">
                        <div className="row justify-content-between align-items-center mb-2">
                          <div className="col-md-6">
                            <h6 className="m-0">
                              Total Students :
                              <b className="text-primary ms-1">
                                {data?.length || 0}
                              </b>
                            </h6>

                            <small className="text-muted">
                              {allFilter?.attendance_type === "regular_p" &&
                                "Regular Present Students"}

                              {allFilter?.attendance_type === "regular_a" &&
                                "Regular Absent Students"}

                              {allFilter?.attendance_type === "both" &&
                                "Absent / Present Students"}
                            </small>
                          </div>

                          <div className="col-md-4 text-end">
                            <span className="badge text-primary bg-label-primary">
                              {allFilter?.from_date}
                            </span>

                            <span className="mx-1">To</span>

                            <span className="badge text-primary bg-label-primary">
                              {allFilter?.to_date}
                            </span>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover table-sm">
                            <thead>
                              <tr className="text-nowrap">
                                <th>#</th>
                                <th>Name</th>
                                <th>Father's Name</th>
                                <th>Mobile No</th>
                                <th>Batch</th>
                                <th>Address</th>
                                <th>Admission Date</th>
                              </tr>
                            </thead>
                            <tbody className="text-capitalize">
                              {data?.length > 0 ? (
                                data?.map((item, index) => (
                                  <tr
                                    onClick={() => {
                                      const modal =
                                        document.getElementById("MainModal");
                                      const bsModal =
                                        window.bootstrap.Modal.getInstance(
                                          modal,
                                        );

                                      if (bsModal) {
                                        bsModal.hide();
                                      }

                                      navigate(
                                        `/student/details?id=${item.id}`,
                                      );
                                    }}
                                  >
                                    <td>{index + 1}</td>
                                    <td className="text-primary">
                                      {item.name} ({item.registration_no})
                                    </td>
                                    <td>{item.father_name}</td>
                                    <td>{item.phone}</td>
                                    <td>
                                      {item?.course_and_fee_info?.batch?.title}
                                    </td>
                                    <td>
                                      {item?.village} {item?.district}{" "}
                                      {item?.state}
                                      {item?.zipcode}
                                    </td>
                                    <td>
                                      {formatToDate(item?.admission_date)}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="10" className="text-center py-5">
                                    <div className="text-muted fw-semibold">
                                      No Students Found
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer  bg-label-primary py-3">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
